/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import book from './book/book.webp'
import camera from './camera/camera.webp'
import computer from './computer/computer.webp'
import mic from './mic/mic.webp'
import musicSheet from './musicSheet/musicSheet.webp'
import newspaper from './newspaper/newspaper.webp'
import notebook from './notebook/notebook.webp'
import paintingPalette from './paintingPalette/paintingPalette.webp'
import passCard from './passCard/passCard.webp'
import popcorn from './popcorn/popcorn.webp'
import spotlight from './spotlight/spotlight.webp'
import vase from './vase/vase.webp'
import videogame from './videogame/videogame.webp'

export const illustrations = {
  book,
  camera,
  computer,
  mic,
  musicSheet,
  newspaper,
  notebook,
  paintingPalette,
  passCard,
  popcorn,
  spotlight,
  vase,
  videogame,
} as const
